const PERSIST_KEY = "persist:root";

type PersistedAuth = {
  accessToken?: string;
  refreshToken?: string;
  backendAccessToken?: string;
  backendRefreshToken?: string;
  profileToken?: string;
};

function readPersistedAuth(): PersistedAuth | null {
  try {
    const root = localStorage.getItem(PERSIST_KEY);
    if (!root) return null;
    const parsed = JSON.parse(root) as { auth?: string };
    if (!parsed?.auth) return null;
    return JSON.parse(parsed.auth) as PersistedAuth;
  } catch {
    return null;
  }
}

export function getPersistedAccessToken() {
  return readPersistedAuth()?.accessToken ?? null;
}

export function getPersistedProfileToken() {
  return readPersistedAuth()?.profileToken ?? null;
}

export function hasPersistedBackendSession() {
  const auth = readPersistedAuth();
  return Boolean(auth?.backendAccessToken ?? auth?.accessToken);
}

export function clearPersistedAuthTokens() {
  try {
    const root = localStorage.getItem(PERSIST_KEY);
    if (!root) return;

    const parsed = JSON.parse(root) as { auth?: string };
    const auth: PersistedAuth = parsed.auth ? JSON.parse(parsed.auth) : {};

    delete auth.backendAccessToken;
    delete auth.backendRefreshToken;
    delete auth.profileToken;
    delete auth.accessToken;
    delete auth.refreshToken;

    parsed.auth = JSON.stringify(auth);
    localStorage.setItem(PERSIST_KEY, JSON.stringify(parsed));
  } catch {
    localStorage.removeItem(PERSIST_KEY);
  }
}
